export const loyaltyCustomerCheck = ({ segments, appConfig }) => {
  const { loyaltyInviteOnlySegmentId } = appConfig;

  if (loyaltyInviteOnlySegmentId) {
    return Boolean(
      segments?.find(
        (segment) => segment.segmentId === loyaltyInviteOnlySegmentId
      )
    );
  }

  return false;
};
